import React from "react";
import { Link } from "react-router-dom";
import "./foretek-logo.css";

type Props = {
  isScrolled: boolean;
  className?: string;
  onClick?: () => void;
};

/**
 * Full logo is used only on large desktop before scroll.
 * Compact logo (without tagline) is used on mobile/tablet and after scroll.
 * No scale transform is used, preventing browser rasterisation blur.
 */
export function ForetekNavbarLogo({ isScrolled, className = "", onClick }: Props) {
  return (
    <Link
      to="/"
      onClick={onClick}
      aria-label="Foretek Solution home"
      className={`foretek-brand ${className}`}
    >
      <span
        className={`foretek-lockup foretek-lockup--full ${isScrolled ? "is-scrolled" : ""
          }`}
      >
        <img
          src="/brand/svg/foretek-logo-full-light.svg"
          alt="Foretek Solution — Committed to Keep You Forward"
          width={1570}
          height={315}
          decoding="sync"
          fetchPriority="high"
          className="foretek-image foretek-image--light"
        />
        <img
          src="/brand/svg/foretek-logo-full-dark.svg"
          alt=""
          aria-hidden="true"
          width={1570}
          height={315}
          decoding="sync"
          fetchPriority="high"
          className="foretek-image foretek-image--dark"
        />
      </span>
    </Link>
  );
}

